import React from 'react';

const Home = () => {
  return <React.Fragment></React.Fragment>;
};

export default Home;
